<template>
  <div class="p-12">
    <Insights :account-id="accountId" />
  </div>
</template>

<script>
import Insights from './customers/components/insights.vue';

export default {
  components: {
    Insights,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
};
</script>
